
import React, {useEffect, useState} from 'react'
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux';
import { Container, Grid,Header, Item, Divider, Dropdown } from 'semantic-ui-react';
import { ChangeIsRtl , ChangeLang} from '../../../../redux/actions/mainActions';
import "./Footer.css"

const Footer = ({}) => {
    const { i18n, t } = useTranslation();
   
    const lang = useSelector((state)=>state.main.lang)
    
    
    const communityLinks = ["Airbnb.org: disaster relief housing",
        "Support Afghan refugees",
        "Combating discrimination"]

    const hostingLinks = ["Try hosting",
        "AirCover: protection for Hosts",
        "Explore hosting resources",
        "Visit our community forum",
        "How to host responsibly"]
    const aboutLinks = ["Newsroom",
        "Learn about new features",
        "Letter from our founders",
        "Careers",
        "Investors",
        "Airbnb Luxe"]
      return <Container >
          <Grid stackable columns={4}>
              <Grid.Row>
                    <Grid.Column>
                        {/* <Header size='small' className="p-1-b p-1-t">{t("footer:ChangeLanguage")}</Header> */}
                       
                    </Grid.Column>
                    
                    <Grid.Column>
                        <Divider />
                        <Header size='small' className="p-1-b p-1-t">Community</Header>
                        {
                           communityLinks.map((item,index)=>{
                               return  <Item key={index} className="p-05-b">
                               <Item.Content  as='a' className="font-light text-black">
                                   {item}
                               </Item.Content>
                           </Item>
                           })
                       }
                    </Grid.Column>
                    
                    <Grid.Column>
                        <Divider />
                        <Header size='small' className="p-1-b p-1-t">Hosting</Header>
                        {
                           hostingLinks.map((item,index)=>{
                               return  <Item key={index} className="p-05-b">
                               <Item.Content  as='a' className="font-light text-black">
                                   {item}
                               </Item.Content>
                           </Item>
                           })
                       }
                    </Grid.Column>
                    
                    <Grid.Column>
                        <Divider />
                        <Header size='small' className="p-1-b p-1-t">About</Header>
                        {
                           aboutLinks.map((item,index)=>{
                               return  <Item key={index} className="p-05-b">
                               <Item.Content  as='a' className="font-light text-black">
                                   {item}
                               </Item.Content>
                           </Item>
                           })
                       }
                    </Grid.Column>
              </Grid.Row>
              <Divider />
              <Grid.Row>
                    <Grid.Column></Grid.Column>
                    <Grid.Column></Grid.Column>
                    <Grid.Column></Grid.Column>
                    <Grid.Column></Grid.Column>

              </Grid.Row>
          </Grid>
      </Container>
}
export default Footer